<template>
  <div v-if="isAdmin" class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <h2
      class="text-center my-4 text-2xl tracking-wider leading-10 font-semibold text-white sm:text-5xl sm:leading-none md:text-4xl"
    >
      Free Bundle Recipients
    </h2>

    <div
      v-if="searchString && data.length !== searchResults.length"
      class="text-white"
    >
      Search results for <strong>{{ searchString }}</strong
      >.
      <span
        class="cursor-pointer text-capitalize font-bold text-pink :hover:text-black"
        @click="showAll"
      >
        Show all
      </span>
    </div>

    <div class="flex flex-row justify-center items-center">
      <input
        class="rounded-l p-2 border-r border-teal bg-lighterblue bg-lighterblue w-1/5 focus:w-1/3 text-blue-900 font-semibold"
        type="search"
        v-model="searchString"
        placeholder="Search..."
      />
      <svg
        @click="searchByEmail"
        xmlns="http://www.w3.org/2000/svg"
        class="h-10 w-10 bg-lighterblue text-teal p-2 rounded-r font-semibold hover:bg-red hover:text:white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
    <div
      class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg w-full sm:w-1/3 mt-5 mx-auto"
    >
      <table class="min-w-full divide-y divide-gray-200 p-2">
        <tbody class="bg-white divide-y divide-darkgreen">
          <tr v-for="(entry, index) in searchResults" :key="index">
            <td class="rowStyle p-2">
              {{ entry.email }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div
          class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { freeBundlesCollection, topicsCollection } from "../utils/firebase";
import { mapGetters } from "vuex";

export default {
  name: "FreeBundles",
  data() {
    return {
      data: [],
      searchString: "",
      searchResults: []
    };
  },
  created() {
    if(this.isAdmin){
      freeBundlesCollection.get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          this.data.push(doc.data());
          this.searchResults.push(doc.data());
        });
      });
    }
  },
  computed: {
    ...mapGetters(["loggedIn", "isAdmin"])
  },
  methods: {
    showAll() {
      this.searchString = "";
      this.searchResults = this.data;
    },
    searchByEmail() {
      const email = this.searchString.trim();
      this.searchResults = this.data.filter(
        d => d.email.toLowerCase() === email.toLowerCase()
      );
    }
  }
};
</script>

<style scoped></style>
